module.exports = __webpack_public_path__ + "img/award-record.fe253288.png";